import { render } from "./EditClientLogoPage.vue?vue&type=template&id=259080a4"
import script from "./EditClientLogoPage.vue?vue&type=script&lang=js"
export * from "./EditClientLogoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__